export enum GuestCountKeys {
  noOfAdults = 'adults',
  noOfJuniors = 'juniors',
  noOfChildren = 'children',
  noOfInfants = 'infants',
  noOfDiscChild = 'discChild',
}
